// The tips table itself: sortable headers, one row per tip, issue colouring, photo / edit / history buttons.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { ISSUE_LABEL, findPlatePhoto, fmtDate, fmtTime, rowTint, statusLabel, toDriveProxy } from './helpers.js';
import { CAM_SEEN_TITLE, CAM_PROBABLE_TITLE } from '../../utils/plates.js';

export default function TipsTable({ allSelected, assignProject, camProbable, camSeen, canWrite, cellValue, enrichForAddPlate, isReviewable, me, openApprovedEditor, openEditor, openHistory, projBusy, projects, projectsByCustomer, projectsById, selected, setAddPlateRow, setHoverPhoto, setPhotoRow, setRawRow, setUnapproveReason, setUnapproveRow, sortArrow, tab, toggle, toggleAll, toggleSort, visibleCols, visibleRows }) {
  return (
    <>
      <div className="card" style={{ padding: '0.5rem', overflow: 'auto', maxHeight: '70vh' }}>
        <table className="fs-table tidy" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
          <thead className="sticky-thead">
            <tr>
              <th><input type="checkbox" checked={allSelected} onChange={toggleAll} /></th>
              {visibleCols.map(c => (
                <th key={c.key} className={c.num ? 'num' : ''} style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => toggleSort(c.key)}>
                  {c.label}{sortArrow(c.key)}
                </th>
              ))}
              <th>Raw</th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.length === 0 && (
              <tr><td colSpan={visibleCols.length + 1 + (isReviewable ? 1 : 0)} style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>Nothing in this category.</td></tr>
            )}
            {visibleRows.map(r => {
              const id = r._id;
              const issues = r._issues || [];
              const tintStyle = (isReviewable || issues.length > 0) ? rowTint(issues) : {};
              const sl = statusLabel(issues);
              return (
                <tr key={id} style={tintStyle}>
                  <td><input type="checkbox" checked={selected.has(id)} onChange={() => toggle(id)} /></td>
                  {visibleCols.map(c => {
                    let v = cellValue(r, c);
                    if (c.key === 'date')           v = fmtDate(v);
                    else if (c.key === 'arrivalTime') v = fmtTime(v);
                    else if (c.key === '_decidedAt')  v = v ? String(v).slice(0,16).replace('T',' ') : '';
                    else if (c.key === 'pctFilled' || c.key === 'pctSolids') v = v != null ? v + '%' : '';
                    else if (c.key === '_excelMatchId') {
                      return <td key={c.key}>{v
                        ? <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: 999, fontSize: '0.8em' }}>matched</span>
                        : <span style={{ background: '#fef9c3', color: '#854d0e', padding: '2px 8px', borderRadius: 999, fontSize: '0.8em' }}>—</span>}</td>;
                    }
                    else if (c.key === '_issues') {
                      const regCust = r._registeredCustomer;
                      return (
                        <td key={c.key}>
                          <span
                            onClick={() => r._raw && setRawRow(r)}
                            title={r._raw ? 'Click to view original sheet row' : ''}
                            style={{
                              background: sl.color + '22', color: sl.color,
                              padding: '2px 8px', borderRadius: 999,
                              fontSize: '0.8em', fontWeight: 600,
                              cursor: r._raw ? 'pointer' : 'default',
                              textDecoration: r._raw ? 'underline dotted' : 'none'
                            }}
                          >{sl.label}</span>
                          {issues.length > 0 && (
                            <div className="small" style={{ color: '#666', marginTop: 2 }}>
                              {issues.map((i, k) => (
                                <span key={i} title={i === 'plate_customer_mismatch' && regCust ? 'Plate is registered to: ' + regCust : ''}>
                                  {(ISSUE_LABEL[i] || i)}
                                  {i === 'plate_customer_mismatch' && regCust && (
                                    <strong style={{ color: '#0369a1', marginLeft: 4 }}> → {regCust}</strong>
                                  )}
                                  {i === 'plate_customer_mismatch' && r._priorApprovals > 0 && (
                                    <span style={{ marginLeft: 6, background: '#dcfce7', color: '#166534', padding: '1px 8px', borderRadius: 999, fontSize: '0.75em', fontWeight: 600 }}
                                          title={'Same plate+customer combo was approved ' + r._priorApprovals + ' time' + (r._priorApprovals === 1 ? '' : 's') + ' before' + (r._priorApprovalLastDate ? ' (last: ' + r._priorApprovalLastDate.slice(0,10) + ')' : '')}>
                                      ✓ approved {r._priorApprovals}× prior
                                    </span>
                                  )}
                                  {i === 'unknown_plate' && (
                                    <>
                                      {(() => {
                                        // Match the server-side gate on PUT /api/plates —
                                        // requireTabForMethod('reference'), which grants access
                                        // to anyone with 'write' or 'admin' on the reference tab.
                                        // Previously this gated on me.isFinance (FINANCE_EMAILS
                                        // env var only), which excluded finance users who came
                                        // in through the modern group-based permission system.
                                        const refPerm = me && me.effectivePermissions && me.effectivePermissions.reference;
                                        const canAddPlate = me && r.licensePlate && (
                                          me.isAdmin || me.isFinance ||
                                          refPerm === 'write' || refPerm === 'admin'
                                        );
                                        if (!canAddPlate) return null;
                                        return (
                                          <button className="link"
                                            onClick={(e) => { e.stopPropagation(); setAddPlateRow(enrichForAddPlate(r)); }}
                                            style={{ marginLeft: 6, padding: '0 6px', fontSize: '0.85em', background: '#0369a1', color: '#fff', border: 0, borderRadius: 3, cursor: 'pointer' }}
                                            title="Add this plate to the registry with the customer + tank size from this row">
                                            + add to registry
                                          </button>
                                        );
                                      })()}
                                      <span style={{ color: '#888', marginLeft: 4, fontStyle: 'italic' }}> (not in registry)</span>
                                    </>
                                  )}
                                  {k < issues.length - 1 ? ', ' : ''}
                                </span>
                              ))}
                            </div>
                          )}
                          {/* Note: standalone 'Plate registered to: X' italic removed.
                              It was misleading because alias resolution can make 'X'
                              and the typed customer be the same canonical name — the
                              row was actually Clean, but the italic implied otherwise.
                              Mismatches still surface via the plate_customer_mismatch
                              issue label, and the Customer cell hover tooltip still
                              shows the registry value for confirmation lookups. */}
                        </td>
                      );
                    }
                    else if (c.key === 'licensePlate') {
                      const photoUrl = findPlatePhoto(r);
                      const proxyUrl = photoUrl ? toDriveProxy(photoUrl, r._id) : null;
                      const alwaysLink = isReviewable;
                      const corrected = !!r._correctedAt;
                      const orig = r._originalFields || {};
                      return <td key={c.key}>
                        {(photoUrl || alwaysLink)
                          ? <a href="#" onClick={(e) => { e.preventDefault(); setPhotoRow({ ...r, _resolvedPhoto: photoUrl }); }}
                               onMouseEnter={(e) => proxyUrl && setHoverPhoto({ url: proxyUrl, plate: v, x: e.clientX, y: e.clientY })}
                               onMouseMove={(e) => proxyUrl && setHoverPhoto((h) => h ? { ...h, x: e.clientX, y: e.clientY } : null)}
                               onMouseLeave={() => setHoverPhoto(null)}
                               style={{ textDecoration: 'underline dotted', color: '#0369a1' }}
                               title={proxyUrl ? 'Click to open photo · hover to preview' : 'Click to inspect (no photo on file)'}>
                              <code>{v || '—'}</code>
                            </a>
                          : <code>{v || '—'}</code>}
                        {camSeen(r.date, v) ? (
                          <span title={CAM_SEEN_TITLE}
                                style={{ marginLeft: 6, color: '#15803d', fontWeight: 700, fontSize: '0.85em' }}>📷✓</span>
                        ) : camProbable(r.date, v) ? (
                          <span title={CAM_PROBABLE_TITLE}
                                style={{ marginLeft: 6, color: '#b45309', fontWeight: 700, fontSize: '0.85em' }}>📷≈</span>
                        ) : null}
                        {corrected && (
                          <span style={{ marginLeft: 6, background: '#dcfce7', color: '#166534', padding: '1px 6px', borderRadius: 999, fontSize: '0.75em' }}
                                title={'Corrected by ' + (r._correctedBy || '') + ' at ' + (r._correctedAt || '') + '\nOriginal:\n  plate: ' + (orig.licensePlate || '—') + '\n  customer: ' + (orig.customer || '—') + '\n  tank: ' + (orig.tankSize != null ? orig.tankSize : '—')}>
                            ✏️ corrected
                          </span>
                        )}
                        {isReviewable && (
                          <button className="link" onClick={() => openEditor(r)}
                                  style={{ marginLeft: 6, color: '#666', fontSize: '0.85em' }}
                                  title="Edit plate / customer / tank size">edit</button>
                        )}
                        {tab === 'approved' && (
                          <>
                            <button className="link" onClick={() => openApprovedEditor(r)}
                                    style={{ marginLeft: 6, color: '#0369a1', fontSize: '0.85em' }}
                                    title="Edit this approved row (creates an audit entry)">edit</button>
                            <button className="link" onClick={() => openHistory(r)}
                                    style={{ marginLeft: 6, color: '#666', fontSize: '0.85em' }}
                                    title="Show audit history for this row">📋 history</button>
                            <button className="link" onClick={() => { setUnapproveReason(''); setUnapproveRow(r); }}
                                    style={{ marginLeft: 6, color: '#c2410c', fontSize: '0.85em' }}
                                    title="Reverse this approval — deletes from Approved, flips any linked sheet row back to Pending">⤺ unapprove</button>
                            {r._editedAfterApproval && (
                              <span title="This row was edited after approval (see history)" style={{ marginLeft: 6, fontSize: '0.85em' }}>📝</span>
                            )}
                          </>
                        )}
                      </td>;
                    }
                    else if (c.key === 'platePhoto') {
                      const url = findPlatePhoto(r);
                      return <td key={c.key}>{url
                        ? <a href={url} target="_blank" rel="noreferrer" className="small" style={{ color: '#0369a1' }}>photo ↗</a>
                        : <span style={{ color: '#aaa' }}>—</span>}</td>;
                    }
                    else if (c.key === 'project_id') {
                      // Project rate-override assignment. Dropdown of the
                      // row-customer's active projects; read-only text when
                      // the viewer can't write or no projects exist.
                      const custKey = String(r.customer || '').toLowerCase().trim();
                      const opts = projectsByCustomer.get(custKey) || [];
                      const cur = r.project_id != null ? projectsById.get(Number(r.project_id)) : null;
                      if (!canWrite || (opts.length === 0 && !cur)) {
                        return <td key={c.key} className="small">{cur ? (cur.code || cur.name) : <span style={{ color: '#ccc' }}>—</span>}</td>;
                      }
                      return (
                        <td key={c.key}>
                          <select value={r.project_id != null ? String(r.project_id) : ''}
                                  disabled={projBusy}
                                  onClick={e => e.stopPropagation()}
                                  onChange={e => assignProject([r._id], e.target.value === '' ? null : Number(e.target.value))}
                                  title={cur ? cur.name : 'Assign a project (bills at project rates)'}
                                  style={{ fontSize: '0.85em', padding: '2px 4px', maxWidth: '10em',
                                           background: r.project_id != null ? '#f3e8ff' : '#fff',
                                           border: '1px solid ' + (r.project_id != null ? '#c084fc' : '#cbd5e1'), borderRadius: 3 }}>
                            <option value="">—</option>
                            {opts.map(p => <option key={p.id} value={String(p.id)}>{p.code || p.name}</option>)}
                            {cur && !opts.some(p => Number(p.id) === Number(r.project_id)) && (
                              <option value={String(r.project_id)}>{cur.code || cur.name} (inactive)</option>
                            )}
                          </select>
                        </td>
                      );
                    }
                    // Defensive coercion: any object value (rare but possible
                    // when a Sheet column contains structured data) gets
                    // JSON.stringify'd so we render readable text instead of
                    // tripping React error #31 'objects are not valid as a
                    // React child'.
                    let safeV = v;
                    if (safeV != null && typeof safeV === 'object') {
                      try { safeV = JSON.stringify(safeV); } catch { safeV = String(safeV); }
                    }
                    const display = safeV != null && safeV !== '' ? (typeof safeV === 'string' && safeV.length > 40 ? safeV.slice(0,37) + '…' : safeV) : (c.num ? '—' : '');
                    const cellTitle = (c.key === 'customer' && r._registeredCustomer && r._registeredCustomer !== r.customer)
                      ? ('Plate is registered to: ' + r._registeredCustomer + '\nTyped on form: ' + (r.customer || '(blank)'))
                      : undefined;
                    return <td key={c.key} className={c.num ? 'num' : ''} title={cellTitle}>{display}</td>;
                  })}
                  <td>{r._raw
                    ? <button className="link" onClick={() => setRawRow(r)} style={{ color: '#0369a1' }}>view…</button>
                    : <span style={{ color: '#aaa' }}>—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
